import React, { useContext, useEffect, useState } from "react";
import "./UsageOverwiew.scss";
import { useTranslation } from "react-i18next";
import AppContext from "../../config/AppContext";
import { getUserOverviewCardCount } from "../../services/UsageInsightService";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ReactComponent as ActiveInfo } from "../../assets/images/ralvie/active-info.svg"
import { ReactComponent as InactiveInfo } from "../../assets/images/ralvie/inactive-info.svg"
import { ReactComponent as WorklogInfo } from "../../assets/images/ralvie/worklog-info.svg"
import { ReactComponent as UsageInfo } from "../../assets/images/ralvie/usage-info.svg"
import { Tooltip } from "@mui/material";
dayjs.extend(utc);
dayjs.extend(timezone);

const UsageOverwiew = ({ startDate, endDate }) => {
  const { t } = useTranslation();
  const { mode } = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [usageData, setUsageData] = useState({
    totalUsers: 0,
    totalActiveUsers: 0,
    totalInactiveUsers: 0,
    totalWorklogCreators: 0,
    usageRate: 0,
  });

  const localTz = dayjs.tz.guess();
  const start = dayjs(startDate).tz(localTz).startOf("day").utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
  const end = dayjs(endDate).tz(localTz).endOf("day").utc().format("YYYY-MM-DDTHH:mm:ss[Z]");

  useEffect(() => {
    const fetchUsageData = async () => {
      try {
        const response = await getUserOverviewCardCount({
          startDate: start,
          endDate: end,
        });
        if (response && response.data) {
          setUsageData({
            totalUsers: response?.data?.data?.totalUsers,
            totalActiveUsers: response?.data?.data?.totalActiveUsers,
            totalInactiveUsers: response?.data?.data?.totalInactiveUsers,
            totalWorklogCreators: response?.data?.data?.totalWorklogCreators,
            usageRate: response?.data?.data?.usageRate,
          });
        }
      } catch (err) {
        console.error("Error fetching usage data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsageData();
  }, [startDate, endDate]);

  return (
    <div className={mode === "dark" ? "usage-overview-dark" : "usage-overview"}>
      <div className={mode === "dark" ? "overview-title-dark" : "overview-title"}>{t("RAL1211")}</div>
      <div className="overview-cards">
        <div className="card total-users">
          <span className="total-users-label">
            {t("RAL1213")}
            <Tooltip title={t("RAL1236")}>
              <ActiveInfo />
            </Tooltip>
          </span>
          <span className="total-users-count">{usageData.totalActiveUsers ? usageData.totalActiveUsers.toLocaleString() : '0'}</span>
        </div>

        <div className="card active-users">
          <span className="active-users-label">
            {t("RAL1214")}
            <Tooltip title={t("RAL1237")}>
              <InactiveInfo />
            </Tooltip>
          </span>
          <span className="active-users-count">{usageData.totalInactiveUsers ? usageData.totalInactiveUsers.toLocaleString() : '0'}</span>
        </div>

        <div className="card inactive-users">
          <span className="inactive-users-label">
            {t("RAL1238")}
            <Tooltip title={t("RAL1239")}>
              <WorklogInfo />
            </Tooltip>
          </span>
          <span className="inactive-users-count">{usageData?.totalWorklogCreators ? usageData.totalWorklogCreators.toLocaleString() : '0'}</span>
        </div>

        <div className="card usage-rate">
          <span className="usage-rate-label">
            {t("RAL1240")}
            <Tooltip title={t("RAL1241")}>
              <UsageInfo />
            </Tooltip>
          </span>
          <span className="usage-rate-count">{usageData.usageRate ? usageData.usageRate : '0'}%</span>
        </div>
      </div>
    </div>
  );
};

export default UsageOverwiew;